module.exports = __webpack_public_path__ + "static/media/whiteDoubts.ca3307ef.svg";